import { Address } from '@/models/Address';

export class RenderHelper {
  // Declare the possible overloads here.
  formatAddress(address1: string, address2: string, suburb: string, postcode: string, state: string, country: string): string
  formatAddress(address: Address | undefined | null): string

  // Implement the actual method here accomodating both overloads.
  /**
   * Formats an address to a html string representation
   * @param  {string|Address} address1?
   * @param  {string} address2?
   * @param  {string} suburb?
   * @param  {string} postcode?
   * @param  {string} state?
   * @param  {string} country?
   * @returns string
   */
  formatAddress(address1?: string | Address | null, address2?: string, suburb?: string, postcode?: string, state?: string, country?: string): string {
    if (!address1) {
      return ''
    }

    let address: Address | null = null

    if (typeof address1 === 'string') {
      address  =
      {
        address1: address1,
        address2: address2,
        suburb: suburb,
        state: state,
        postcode: postcode,
        country: country
      }
    } else {
      address = address1 as Address
    }

    let formatted = address.address1 ?? ''
    if (formatted.length > 0 && address.address2) {
      formatted = `${formatted}<br/>`
    }

    if (address.address2) {
      formatted = `${formatted}${address.address2}`
    }

    let location = `${address.suburb} ${address.postcode} ${this.mapState(address.state)} ${address.country}`.replace('undedfined', '').trim()

    if (address.state?.toLowerCase() === 'other') {
      location = `${address.suburb} ${address.postcode} ${address.stateOther} ${address.country}`
    }

    if (formatted.length > 0 && location.length > 0) {
      formatted = `${formatted}<br/>${location}`
    }

    return formatted
  }

  private mapState(state?: string): string | undefined
  {
      switch (state)
      {
          case "NSW":
              return "New South Wales";
          case "VIC":
              return "Victoria";
          case "TAS":
              return "Tasmania";
          case "SA":
              return "South Australia";
          case "WA":
              return "Western Australia";
          case "NT":
              return "Northern Territory";
          case "QLD":
              return "Queensland";
      }

      return state;
  }

  /**
   * Returns false if the value is null, undefined or empty
   * @param  {string|null|undefined} value
   * @returns boolean
   */
  isNullOrEmpty(value: string | null | undefined): boolean {
    return !value || value.length === 0;
  }

  /**
   * Converts new lines in a string to &lt;br /&gt;
   * @param {string} value
   * @param {boolean} useParagraphs - use Paragraph tags instead of break, defaults to false.
   * @returns string
   */
  convertNewLines(value: string, useParagraphs = false): string {
    if (!value) return "";

    const lines = value.split('\n')
    if (useParagraphs) {
      return lines.filter(line => line.length != 0)
                  .map(line => `<p>${line}</p>`)
                  .join('')
    }

    return lines.join("<br />")
  }
}
